import ADB from "../../../../libs/MediaSDK";
import { debug } from "@medscape/streaming-video-player/src/js/utils/debug-log";
const { Event: ADB_MEDIA_EVENTS } = ADB.Media;
import { akamai } from "../../../globals";
const { TIME_UPDATE, ENDED, SEEKED, DESTROY } = akamai.amp.Events;

class Chapters {
  constructor(amp, tracker) {
    this.amp = amp;
    this.tracker = tracker;

    this.stateName = "";
    this.subscriptions = [];
    let chapters = amp.media.metadata.chapters || [];
    this.chapters = chapters.map((chapter, index) => {
      return Object.assign({ active: false, position: index + 1 }, chapter);
    });
    debug.log("[MediaAnalyticsTracking][Chapters][constructor]:", this);
  }
  get activeChapter() {
    const activeChapter = this.chapters.find((chapter) => {
      return chapter.active === true;
    });
    return activeChapter;
  }
  get length() {
    return this.chapters.length;
  }
  destroy() {
    this.subscriptions.forEach((subscription) => {
      subscription.unsubscribe();
    });
    this.subscriptions = [];
  }
  end() {
    this.destroy();
  }
  start() {
    this.destroy();
    const { amp, chapters } = this;
    if (chapters.length > 0) {
      let lastChapter = chapters[chapters.length - 1];
      lastChapter.length = amp.duration - lastChapter.startTime;
      this.updateChapters(amp.getCurrentTime());
      const { activeChapter } = this;
      if (activeChapter != null) {
        this.trackStart(activeChapter);
      }

      const timeupdate$ = amp.AmpEventsSources[TIME_UPDATE].subscribe(
        (data) => {
          this.onTimeupdate(data.state.currentTime);
        }
      );
      const ended$ = amp.AmpEventsSources[ENDED].subscribe((data) => {
        this.trackComplete();
      });

      const seeked$ = amp.AmpEventsSources[SEEKED].subscribe((data) => {
        this.seeking = false;
        this.onSeeked(data.state.currentTime);
      });
      const destroy$ = amp.AmpEventsSources[DESTROY].subscribe((data) => {
        this.destroy();
      });
      this.subscriptions = [timeupdate$, seeked$, ended$, destroy$];
    }
  }
  updateChapters(currentTime = 0) {
    const chapters = this.chapters.map((chapter) => {
      const { startTime, length } = chapter;
      const endTime = startTime + length;
      const active = currentTime >= startTime && currentTime <= endTime;
      const updateChapter =
        chapter.active === active
          ? chapter
          : Object.assign({}, chapter, {
              active,
            });
      return updateChapter;
    });
    this.chapters = chapters;
  }

  onSeeked(currentTime = 0) {
    const { activeChapter: prevChapter } = this;
    this.updateChapters(currentTime);
    const { activeChapter } = this;
    debug.log(
      "[MediaAnalyticsTracking][Chapter][onSeeked]\ncurrentTime:",
      currentTime,
      "\nprevChapter:",
      prevChapter,
      "\nactiveChapter:",
      activeChapter
    );
    if (activeChapter.position !== prevChapter.position) {
      this.trackSkip();
      this.trackStart(activeChapter);
    }
  }
  onTimeupdate(currentTime = 0) {
    if (this.amp.seeking === false) {
      const { activeChapter: prevChapter } = this;
      this.updateChapters(currentTime);
      const { activeChapter } = this;
      if (
        activeChapter != null &&
        prevChapter != null &&
        activeChapter.position === prevChapter.position + 1
      ) {
        this.trackComplete();
        this.trackStart(activeChapter);
      }
    }
  }
  trackStart(chapter) {
    const { tracker } = this;
    const { chapterName, position, length, startTime } = chapter;
    const stateName = ADB_MEDIA_EVENTS.ChapterStart;
    if (stateName != this.stateName) {
      const chapterObject = ADB.Media.createChapterObject(
        chapterName,
        position,
        length,
        startTime
      );
      debug.log(
        "[MediaAnalyticsTracking][Chapter][trackStart] tracker.trackEvent \n\tstateName:",
        stateName,
        "\n\tstateObject:",
        chapterObject
      );

      tracker.trackEvent(stateName, chapterObject);
    }
    this.stateName = stateName;
  }
  trackSkip() {
    const { tracker } = this;
    const stateName = ADB_MEDIA_EVENTS.ChapterSkip;
    if (stateName != this.stateName) {
      debug.log(
        "[MediaAnalyticsTracking][Chapter][trackSkip] tracker.trackEvent \n\tstateName:",
        stateName
      );
      tracker.trackEvent(stateName);
    }
    this.stateName = stateName;
  }
  trackComplete() {
    const { tracker } = this;
    const stateName = ADB_MEDIA_EVENTS.ChapterComplete;
    if (stateName != this.stateName) {
      debug.log(
        "[MediaAnalyticsTracking][Chapter][trackComplete] tracker.trackEvent \n\tstateName:",
        stateName
      );
      tracker.trackEvent(stateName);
    }
    this.stateName = stateName;
  }
}

export default Chapters;
